import React from 'react';
import { Wrench, TestTube, Flame, FileCheck, Truck, Headphones } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../mock';

const iconMap = {
  'Wrench': Wrench,
  'TestTube': TestTube,
  'Flame': Flame,
  'FileCheck': FileCheck,
  'Truck': Truck,
  'Headphones': Headphones
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Beyond material supply, we offer comprehensive services to support your manufacturing 
            and fabrication needs with technical expertise and quality assurance.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg bg-white">
                <CardHeader className="text-center pb-4">
                  <div className="mx-auto w-16 h-16 bg-[#022d47]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#022d47] transition-colors duration-300">
                    <IconComponent className="h-8 w-8 text-[#022d47] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl text-slate-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center text-slate-600">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Process Flow */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-slate-900 text-center mb-12">
            Our Quality Process
          </h3>
          
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: "01", title: "Material Sourcing", desc: "Premium materials from certified mills" },
              { step: "02", title: "Quality Inspection", desc: "Rigorous testing and verification" },
              { step: "03", title: "Processing & Cutting", desc: "Precision machining to specifications" },
              { step: "04", title: "Delivery & Support", desc: "Timely delivery with technical support" }
            ].map((step, index) => (
              <div key={index} className="text-center relative">
                <div className="w-16 h-16 bg-[#022d47] text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  {step.step}
                </div>
                <h4 className="font-semibold text-slate-900 mb-2">{step.title}</h4>
                <p className="text-slate-600 text-sm">{step.desc}</p>
                
                {index < 3 && (
                  <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-slate-300 transform -translate-x-8"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};